var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"align-center"},[_c('v-col',{staticClass:"subtitle-2",attrs:{"cols":"3"}},[_vm._v("Tax")]),_c('v-col',[_c('f-percent',{attrs:{"outlined":"","hide-details":"","dense":"","value":_vm.value},on:{"input":function($event){return _vm.updateValue($event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }